import React from "react";
import "./App.css";
import Header from "./components/header";
import Hero from "./components/hero";
import AppSection from "./components/app-section";
import ImageSlider from "./components/side-scroller";
import CardsSection from "./components/cards-section";
import CellphoneSection from "./components/cellphone-section";
import HowToPlaySection from "./components/how-to-play-section";
import CollectionSection from "./components/collection-section";
import FaqSection from "./components/faq-section";
import Footer from "./components/footer";

function App() {
  return (
    <div className="App" style={{ overflow: "hidden" }}>
      <head title={"Bizarrap Social Club"}>
        <style>
          @import
          url('https://fonts.googleapis.com/css2?family=Dosis&display=swap');
          @import
          url('https://fonts.googleapis.com/css2?family=Dosis&family=IBM+Plex+Sans&display=swap');
          @import url("https://use.typekit.net/mgo4mbw.css");
        </style>
        <title>Bizarrap Social Club</title>
      </head>
      <Header />
      <Hero />
      <AppSection />
      <ImageSlider />
      <CardsSection />
      <CellphoneSection />
      <HowToPlaySection />
      <CollectionSection />
      <FaqSection />
      <Footer />
    </div>
  );
}

export default App;
